import './style.css';

interface BallProps{
color: string;
number: number | string;
width?: string | number;
height?: string | number;
}

export default function Ball({color, number, width, height}: BallProps) {
  const customStyle = {
    backgroundColor: color,
    width: width ?? undefined,
    height: height ?? undefined,
  };

  return (
    <div className="d-flex justify-content-center align-items-center px-2">
      <div className="billiard-ball" style={customStyle}>
        <div className="ball-center">
          <span className="ball-number">{number}</span>
        </div>
      </div>
    </div>
  );
}
